/** The schedule fields of a campaign, in epoch seconds. */
export type CampaignSchedule = {
  scheduled_start?: number | null;
  scheduled_stop?: number | null;
};

/** Whether the campaign is scheduled to start or stop after `nowSeconds`. */
export function hasFutureSchedule(campaign: CampaignSchedule, nowSeconds: number): boolean {
  const { scheduled_start: start, scheduled_stop: stop } = campaign;
  return (start != null && start > nowSeconds) || (stop != null && stop > nowSeconds);
}
